module.exports = __webpack_public_path__ + "img/500.653fe29.svg";